import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import ListMasterDataBase from "./ListMasterDataBase";
import { setBreadCrumb } from "../../../../store/userSlice";

export default function MasterDataBase() {
  const dispatch = useDispatch();
  const title = [{ label: "ops 2 master database", link: "/dashboard/ops" }];
  
  useEffect(() => {
    dispatch(setBreadCrumb(title));
  }, []);

  const token = localStorage.getItem("nodeToken");

  return (
    <div className="p-5">
      <ListMasterDataBase token={token} />
    </div>
  );
}
